import { BloodPressureDtoInOut } from "../../generated";
import { BloodPressureValue } from "../../model/challenge/BloodPressureValue";

export const parseBloodPressure = (data: BloodPressureDtoInOut): BloodPressureValue => {
  return {
    systolic: data.systolic,
    diastolic: data.diastolic,
  };
};
